import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import { FormGroup, Label } from 'reactstrap';

const ContainerStyles = {
   padding: '12px',
   fontSize: '1em',
   backgroundColor: '#dff0d8',
   border: '1px solid green',
};

const FieldRadioItem = (props) => {
   return (
      <div style={ContainerStyles}>
         {props?.options?.map((option) => (
            <FormGroup check key={option.key}>
               <Label check>
                  <Field type='radio' name={props.name} value={option.value}/>
                  &nbsp;
                  {option.label}
               </Label>
            </FormGroup>
         ))}
      </div>
   );
};

FieldRadioItem.propTypes = {
   name: PropTypes.string.isRequired,
   options: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      key: PropTypes.oneOfType([
         PropTypes.string,
         PropTypes.number,
      ]).isRequired,
   })).isRequired,
};

export default FieldRadioItem;
